import styled, { css } from "styled-components";
import { media } from "src/styles/mixins";

export const UserDeckWrapper = styled.div<{ isVisible: boolean }>`
  display: flex;
  visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.background};
  justify-content: space-around;
  border-top: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};

  ${media.up("LAPTOP")`
    width: auto;
    border: none;
  `}

  ${({ isVisible }) =>
    !isVisible &&
    css`
      ${media.down("TABLET")`
         height: ${isVisible ? "var(--user-deck-height)" : "0px"};
    `}
    `};
`;

export const UserCardsWrapper = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  width: 100%;
  overflow-y: hidden;
  overflow-x: scroll;
  scroll-behavior: smooth;

  padding: 0 32px 16px 32px;

  @-moz-document url-prefix() {
    /* Disable scrollbar Firefox */
    scrollbar-width: none;
  }

  &::-ms-webkit-scrollbar {
    display: none;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &::-moz-scrollbar {
    display: none;
  }

  & > * {
    flex: 0 0 auto;
    margin-top: 0;
  }

  & > *:not(:first-child) {
    margin-left: 10px;
  }

  & > *:first-child {
    margin-left: auto;
  }
  & > *:last-child {
    margin-right: auto;
  }

  ${media.up("LAPTOP")`
    & > *:not(:first-child) {
      margin-left: 24px;
    }

    & > * {
      margin-top:0;
    }
  `}
`;

export const UserDeckText = styled.div`
  @media ${({ theme }) => theme.mq.md} {
    display: block;
    font-size: ${({ theme }) => theme.fonts.sizes.xxs};
    line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  }
`;

export const UserDeckScrollButton = styled.button<{ visible?: boolean }>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border: 0;
  outline: 0;
  background: white;
  padding-left: 8px;
  cursor: pointer;
  margin-top: 2px;

  &:nth-child(2) {
    left: unset;
    right: 0;
    padding-right: 8px;
  }

  svg {
    margin-top: 10px;
  }

  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;
